import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import Aux from "../../../../../hoc/Auxilary";
import { Button } from 'rsuite'
import SelectionFields from "../../../../../hoc/UI/SelectionFields/SelectionFields";

class ContractClaimForm extends Component {
  render() {
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
            this.props.setFieldTouched("cause_type_id", true);
            this.props.setFieldTouched("claim_cost", true);
            this.props.setFieldTouched("claim_name", true);
            this.props.setFieldTouched("claim_status_id", true);
            this.props.setFieldTouched("claim_date", true);
          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;

            if (values.claim_date) {
                values.claim_date = new Date(values.claim_date).toJSON()
            }

          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form>
          <fieldset disabled={this.props.disabled}>
              <small className={"d-block col-12"}><span style={{color:"red"}}>*</span> required</small>
              <SelectionFields
                  showError={this.props.errors.cause_type_id && this.props.touched.cause_type_id}
                  size={"col-12"}
                  id={"cause_type_id"}
                  url={`cause_type_lkp`}
                  showElem={"type_name"}
                  label={"Cause Type"}
                  value={this.props.values["cause_type_id"] || "default"}
                  isRequired={true}
                  errorMessage={this.props.errors.cause_type_id && this.props.touched.cause_type_id && (
                      <small className="text-danger">{this.props.errors.cause_type_id}</small>
                  )}
              />

        <div className={"col-12"}>
        <label
            style={this.props.errors.claim_cost && this.props.touched.claim_cost && {color: "red"}}
            className="required"
            htmlFor={"claim_cost"}>
            Claim Cost
        </label>

          <Field
              style={this.props.errors.claim_cost && this.props.touched.claim_cost && {borderColor: "red"}}
              className="form-control-sm form-control"
                id={"claim_cost"}
            name={"claim_cost"}
            value={this.props.values.claim_cost || ""}
          />
            {this.props.errors.claim_cost && this.props.touched.claim_cost && (
                <small className="text-danger">{this.props.errors.claim_cost}</small>
            )}

        </div>





        <label className="col-12" style={this.props.errors.claim_date && this.props.touched.claim_date && {color: "red"}}>
          Claim Date
                        <Field
                className="form-control-sm form-control"
            name={"claim_date"}
            value={this.props.values.claim_date || null}
          />
            {this.props.errors.claim_date && this.props.touched.claim_date && (
                <small className="text-danger">{this.props.errors.claim_date}</small>
            )}
        </label>
          <div className={"col-12"}>
        <label
            style={this.props.errors.claim_name && this.props.touched.claim_name && {color: "red"}}
            className="required"
            htmlFor={"claim_name"}>
          Claim Name
        </label>

              <Field
                  style={this.props.errors.claim_name && this.props.touched.claim_name && {borderColor: "red"}}
                  className="form-control-sm form-control"
            id={"claim_name"}
                name={"claim_name"}
            value={this.props.values.claim_name || ""}
          />
              {this.props.errors.claim_name && this.props.touched.claim_name && (
                  <small className="text-danger">{this.props.errors.claim_name}</small>
              )}
          </div>
          <SelectionFields
              showError={this.props.errors.claim_status_id && this.props.touched.claim_status_id}
              size={"col-12"}
              id={"claim_status_id"}
              url={`claim_status_lkp`}
              showElem={"status_name"}
              label={"Claim Status"}
              value={this.props.values["claim_status_id"] || "default"}
              isRequired={true}
              errorMessage={this.props.errors.claim_status_id && this.props.touched.claim_status_id && (
                  <small className="text-danger">{this.props.errors.claim_status_id}</small>
              )}
          />


              <SelectionFields
                  size={"col-12"}
                  id={"resolution_type_id"}
                  url={`resolution_type_lkp`}
                  showElem={"name"}
                  label={"Resolution Type"}
                  value={this.props.values["resolution_type_id"] || "default"}
                  isRequired={false}
              />


        <label className="col-12">
          Content
                        <Field
                            component={"textarea"}
                className="form-control-sm form-control" name={"content"} value={this.props.values.content || ""} />
        </label>


          </fieldset>



          {this.props.disabled ? (<Button className={"ml-2"} type="button" onClick={this.props.toggleSmallModalHandler}>
              Cancel
          </Button>) : (
              <div>
                {!this.props.currentContractClaim ? (
                  <Aux>
                    <Button
                        color={"blue"}
                      type="button"
                      onClick={() => {
                        validAndHandle(this.props.add, this.props.values);
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                        className={"ml-2"}
                        color={"red"}
                        type="button" onClick={this.props.handleReset}>
                      Reset
                    </Button>
                  </Aux>
                ) : (
                  <Aux>
                    <Button
                      type="button"
                      color={"blue"}
                      onClick={() => {
                        validAndHandle(this.props.update, this.props.values);
                      }}
                    >
                      Update
                    </Button>
                    <Button
                        color={"red"}
                        className={"ml-2"}
                        type="button" onClick={this.props.handleReset}>
                      Reset
                    </Button>
                  </Aux>
                )}
                  <Button
                      className={"ml-2"}
                      type="button" onClick={this.props.toggleSmallModalHandler}>
                      Cancel
                  </Button>
            </div>
        )}
      </Form>
    );
  }
}

var contractClaimSchema = Yup.object().shape({
    cause_type_id: Yup.number().required(),
    claim_cost: Yup.number().required().typeError("Number required"),
    claim_name: Yup.string().required(),
    claim_status_id: Yup.number().required(),
    claim_date: Yup.date().nullable().typeError("Invalid date"),
});

export default withFormik({
  validationSchema: contractClaimSchema,
  enableReinitialize: true,

  mapPropsToValues({ currentContractClaim }) {
    return {
      ...currentContractClaim
    };
  }
})(ContractClaimForm);
